// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";

import {Colors} from "../../../assets/Colors";
import {fetchGet, fetchPut} from "../../../fetchers";
import {useMutation} from "@tanstack/react-query";
import {DynamicTableSimple} from "../../../components/tablecard/DynamicTable";
import {Card} from "@material-tailwind/react";
import {isRequired, useForm} from "../../../components/isRequired";
import {HrdInputGenerator} from "../../../components/form/HrdInputGenerator";
import 'react-toastify/dist/ReactToastify.css';
import {BiArrowBack} from "react-icons/bi";
import {useLocation, useNavigate} from "react-router-dom";

const ApprovalPengeluaranBarangPage = ({}) => {
    let initialState = {
        BisnisUnitID: "",
        Tanggal: new Date()
    };

    let initialStateModal = {};
    const validations = [(
        {UserPCName}) => isRequired(UserPCName) || {UserPCName: "Nama UserPC wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Status wajib diisi"},
        ({KelompokID}) => isRequired(KelompokID) || {KelompokID: "Kelompok wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Kelompok wajib diisi"},
        ({DetailAccountID}) => isRequired(DetailAccountID) || {DetailAccountID: "Detail Account wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Detail Account wajib diisi"},
    ];

    const {
        changed,
        values,
        isValid,
        touched,
        submitHandler,
        customHandler,
        changeHandler,
        errors,
        blastChange
    } = useForm(initialState, validations);


    const barang = useMutation(formData => fetchGet("Master/Barang/min"))
    const activity = useMutation(formData => fetchGet("Master/Activity/min"))
    const [buttonTouched, setButtonTouched] = useState(false);
    const [detail, setDetail] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [modalDetail, setModalDetail] = useState(initialStateModal);
    const [modalID, setModalID] = useState(0);
    const ModalOpener = (detail) => {
        setShowModal(true)
    }
    const param = useLocation();

    const mutationGet = useMutation(formData => fetchGet("Procurement/GoodsExpenditurev2/" + formData))
    const mutationUpdate = useMutation(formData => fetchPut("Procurement/GoodsExpenditure/approval", formData))

    const ModalEdit = (detail, id) => {
        setModalID(id)
        setModalDetail(detail)
        setShowModal(true)
        setShowModalEdit(true)
    }

    const ModalDelete = (id) => {
        let newDetail = [...detail]
        newDetail.splice(id, 1);
        setDetail(newDetail)
    }

    const navigate = useNavigate();

    useEffect(() => {
        barang.mutate()
        activity.mutate()
        if (param.state) {
            mutationGet.mutate(param.state.GoodsExpenditureID.replaceAll("/","-"))
        }
    }, []);

    useEffect(() => {
        if (mutationUpdate) {
            if (mutationUpdate.isSuccess) {
                navigate("/approval-list")
            }
        }
    }, [mutationUpdate.status]);


    useEffect(() => {
        if (mutationGet.data) {
            setDetail((mutationGet.data.data.Data ?? []).map(d => ({...d, QtyKeluarAsli: d.QtyKeluar})))
            blastChange(mutationGet.data.data)
        }
    }, [mutationGet.status]);

    const header = [
        {name: "Barang", key: "BarangID", modifiers: "Barang"},
        {name: "Satuan", key: "BarangID", modifiers: "BarangSatuan"},
        {name: "Qty Diminta", key: "QtyDiminta", modifiers: "number"},
        {name: "Qty Keluar", key: "QtyKeluar", modifiers: "number"},
        {name: "Activity", key: "ActivityID", modifiers: "Activity"},
        {name: "Keterangan", key: "Keterangan", modifiers: "Text"},
    ]

    const modalHandler = (value, names) => {
        const newValues = {...modalDetail, [names]: value};
        setModalDetail(newValues);
    };

    const modalHandlerText = (event) => {
        const newValues = {...modalDetail, [event.target.name]: event.target.value};
        setModalDetail(newValues);
    };

    const Kirim = (type) => {
        const payload = {"GoodsExpenditureID": param.state.GoodsExpenditureID, "Approved": type, ...values};
        if (type === "1") {
            // Revisi Qty Keluar: hanya baris yang nilainya berubah dari data asli.
            const revisi = (detail ?? []).filter(d => d.QtyKeluarAsli !== undefined
                && parseFloat(d.QtyKeluar || 0) !== parseFloat(d.QtyKeluarAsli || 0))
                .map(d => ({GoodsExpenditureListID: String(d.GoodsExpenditureListID), QtyKeluar: parseFloat(d.QtyKeluar) || 0}));
            if (revisi.length > 0) {
                const salah = (detail ?? []).find(d => (parseFloat(d.QtyKeluar) || 0) > (parseFloat(d.QtyDiminta) || 0));
                if (salah) {
                    window.alert("Qty Keluar " + (salah.NamaBarang ?? salah.BarangID) + " tidak boleh melebihi Qty Diminta");
                    return;
                }
                if (!window.confirm("Qty Keluar direvisi. Stok akan disesuaikan dan jurnal dicatat sesuai qty baru. Lanjutkan Approve?")) return;
                payload.Revisi = revisi;
            }
        }
        mutationUpdate.mutate(payload)

    }


    // Halaman ini HANYA bisa dibuka lewat Daftar Approval — dokumennya dikirim
    // sebagai state navigasi, bukan lewat URL. Tanpa penjaga ini, mengetik/mem-bookmark
    // URL-nya (atau membukanya di tab baru) memberi layar putih tanpa sebab.
    if (!param.state) {
        return (<div className="md:ml-64">
            <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto"/>
            <div className="px-3 md:px-8 h-auto -mt-32">
                <div className="container mx-auto max-w-full">
                    <div className="grid grid-cols-1 px-4">
                        <Card>
                            <div className="p-8 text-center">
                                <p className="text-gray-800 font-semibold mb-2">
                                    Dokumen belum dipilih
                                </p>
                                <p className="text-sm text-gray-600 mb-6">
                                    Halaman approval ini dibuka dari Daftar Approval. Pilih dokumen
                                    Pengeluaran Barang di sana terlebih dahulu.
                                </p>
                                <button
                                    onClick={() => navigate("/approval-list")}
                                    className="bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                                >
                                    Ke Daftar Approval
                                </button>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </div>);
    }

    // Dokumen tanpa item: dulu seluruh response kosong sehingga layar putih tanpa
    // penjelasan. Sekarang header tetap terisi, dan kondisi ini dinyatakan terang-terangan
    // karena backend menolak Approve untuk dokumen semacam ini.
    const tanpaItem = mutationGet.isSuccess && (!detail || detail.length === 0);

    return (<div className="md:ml-64">
        <div
            style={{background: Colors.primary}}
            className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
            </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 px-4">
                    <Card>
                        <div className="flex flex-col  mt-5">
                            <div className="flex w-full justify-end flex-col sm:flex-row ">
                                <button
                                    onClick={() => navigate("/gudang/transaction/form-pengeluaran-barang")}
                                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                                >
                                    <BiArrowBack className="text-xl text-gray-800 pr-2"/>
                                    Kembali
                                </button>
                                <button
                                    onClick={() => Kirim("1")}
                                    disabled={tanpaItem}
                                    title={tanpaItem ? "Dokumen tidak punya item — tidak bisa di-approve" : "Approve dokumen"}
                                    className="bg-green-100 flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-gray-800"
                                >
                                    {mutationUpdate.isLoading ?
                                        <>
                                            <svg aria-hidden="true" role="status"
                                                 className="inline mr-3 w-4 h-4 text-white animate-spin"
                                                 viewBox="0 0 100 101"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="#E5E7EB"/>
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="current
                                       Color"/>
                                            </svg>
                                            Loading
                                        </>
                                        :
                                        "Approve"
                                    }
                                </button>
                                <button
                                    onClick={() => Kirim("2")}
                                    className="bg-red-400 flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                                >
                                    {mutationUpdate.isLoading ?
                                        <>
                                            <svg aria-hidden="true" role="status"
                                                 className="inline mr-3 w-4 h-4 text-white animate-spin"
                                                 viewBox="0 0 100 101"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="#E5E7EB"/>
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="current
                                       Color"/>
                                            </svg>
                                            Loading
                                        </>
                                        :
                                        "Tolak"
                                    }
                                </button>
                            </div>

                            <div className="w-1/3">
                                <HrdInputGenerator type={"dateLock"} value={values} name={"Tanggal"}
                                                   title={"Tanggal"}
                                                   onChange={customHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={false}
                                />
                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"text"} value={values} name={"NamaPeminta"}
                                                   title={"Nama Peminta"}
                                                   onChange={changeHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={false}
                                />
                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"text"} value={values} name={"Keterangan"}
                                                   title={"Keterangan"}
                                                   onChange={changeHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={false}
                                />
                            </div>


                            <hr/>
                            {tanpaItem && (
                                <div className="m-4 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3">
                                    <p className="text-sm font-semibold text-amber-900">
                                        Dokumen ini tidak memiliki item barang
                                    </p>
                                    <p className="text-xs text-amber-800 mt-1">
                                        Detail barangnya tidak pernah tersimpan, jadi tidak ada yang bisa
                                        disetujui — tombol Approve dinonaktifkan. Gunakan Tolak untuk
                                        mengeluarkannya dari antrean approval.
                                    </p>
                                </div>
                            )}
                            <p className="mx-4 mt-3 text-xs text-gray-600">
                                Qty Keluar boleh direvisi sebelum Approve (maksimal sebesar Qty Diminta; isi 0 untuk
                                membuang barang). Stok sudah terkunci untuk dokumen ini; saat Approve, stok disesuaikan
                                dan jurnal dicatat sesuai qty akhir. Jika Ditolak, stok dikembalikan dan tidak ada jurnal.
                            </p>
                            <div className="overflow-x-auto m-4">
                                <table className="table-auto w-full text-sm">
                                    <thead>
                                    <tr className="text-left border-b">
                                        <th className="p-2">Barang</th>
                                        <th className="p-2 text-right">Qty Diminta</th>
                                        <th className="p-2 text-right">Qty Keluar</th>
                                        <th className="p-2">Activity</th>
                                        <th className="p-2">Keterangan</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {(detail ?? []).map((d, i) => {
                                        const berubah = parseFloat(d.QtyKeluar || 0) !== parseFloat(d.QtyKeluarAsli || 0);
                                        return (
                                            <tr key={d.GoodsExpenditureListID ?? i} className="border-b">
                                                <td className="p-2">{d.NamaBarang ?? d.BarangID}</td>
                                                <td className="p-2 text-right">{d.QtyDiminta}</td>
                                                <td className="p-2 text-right">
                                                    <input type="number" min="0" step="any"
                                                           max={d.QtyDiminta}
                                                           className={"w-28 border rounded px-2 py-1 text-right " + (berubah ? "bg-yellow-50 border-yellow-400" : "")}
                                                           value={d.QtyKeluar ?? ""}
                                                           onChange={e => {
                                                               const v = e.target.value;
                                                               setDetail(prev => prev.map((x, idx) => idx === i ? {...x, QtyKeluar: v} : x));
                                                           }}/>
                                                </td>
                                                <td className="p-2">{d.NamaActivity ?? d.ActivityID}</td>
                                                <td className="p-2">{d.Keterangan}</td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Card>

                </div>
            </div>
        </div>
    </div>);
};

export default ApprovalPengeluaranBarangPage;
